import React from 'react';
import LinkedInIcon from '../../../../../static/icons/linkedInIcon';

const LinkedInLogin = ({ buttonText, className, disabled, onClick }) => (
  <button
    type="button"
    disabled={disabled}
    className={`${
      disabled ? 'bg-gray-300' : 'bg-secondary-600 global-hover'
    } ${className} !text-white px-6 py-3 flex items-center rounded-full gap-2 justify-center uppercase`}
    onClick={onClick}
  >
    {buttonText}
    <LinkedInIcon color="#fff" size={20} />
  </button>
);

export default LinkedInLogin;
